import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  getFollowupLead,
  getInsentiveType,
} from "reduxStore/action/masterActions";
import { propertyForm } from "reduxStore/action/propertyActions";
import { getUserFilterDetail } from "reduxStore/action/usersActions";
import { parentUserList } from "reduxStore/action/usersActions";
import strings from "translate/language";
import {
  handleListResponse,
  seo,
  ValidateExtensionImgeVideo,
} from "utils/utils";
import { getRoleList } from "reduxStore/action/roleActions";
import Breadcrumb from "component/common/breadcrumb";
import {
  propertyrole,
  SourcingManager,
  ClosingManager,
  CPAgent,
  ChannelPartner,
  SubAdmin,
  HR,
  SourcingTL,
  ClosingTL,
} from "utils/constants";
import Button from "../../component/Button";

const AddNewPropNext = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { property_id = "" } = params || {};
  const [uploadFields, setUploadFields] = useState([{ file: "" }]);
  const [formState, setFormState] = useState({});
  const [allocationAddMore, setAllocationAddMore] = useState(true);
  const [formVaild, setFormVaild] = useState({});
  const [userList, setUserList] = useState([]);
  const [leadFollowUp, setLeadFollowUp] = useState([]);
  const [rolesList, setRolesList] = useState(propertyrole);
  const [insentiveTypes, setInsentiveTypes] = useState([]);
  const [ParentUserList, setParentUserList] = useState([]);
  // Allocation_clone
  const [propertyAllocation, setPropertyAllocation] = useState([
    {
      role_id: "",
      users: [],
      selectedUsers: [],
    },
  ]);
  const [propertyFields, setPropertyFields] = useState([{ property_name: "" }]);
  // insetive_clone
  const [insetiveState, setInsetive] = useState([
    { insentive_type_id: "", amount: "" },
  ]);
  const propertyFormSelector = useSelector((state) => state.propertyForm) || {};
  const insentiveTypesSelector =
    useSelector((state) => state.insentiveTypes) || {};
  const userListSelector = useSelector((state) => state.userData);
  const propertySelector = useSelector((state) => state.propertyData);
  const followUpSelector = useSelector((state) => state.followUpMaster);
  const getRoleListSelector = useSelector((state) => state.roleData) || {};

  useEffect(() => {
    if (
      propertyAllocation[0].selectedUsers.length === 0 ||
      !propertyAllocation[0].role_id
    ) {
      setAllocationAddMore(true);
    } else {
      if (
        propertyAllocation.some(
          (i) => i.selectedUsers.length === 0 || i.role_id === ""
        )
      ) {
        setAllocationAddMore(true);
      } else if (
        propertyAllocation.some(
          (i) => i.selectedUsers.length === 1 || i.role_id !== ""
        )
      ) {
        setAllocationAddMore(false);
      }
    }
  }, [propertyAllocation]);
  useEffect(() => {
    const { response } = getRoleListSelector;
    if (response) {
      if (response?.status === 200) {
        let filterData = handleListResponse(response.data).filter(
          (i) =>
            // i._id !== SourcingManager &&
            // i._id !== ClosingManager &&
            i._id !== CPAgent &&
            i._id !== ChannelPartner &&
            i._id !== SubAdmin &&
            i._id !== HR
        );
        setRolesList(filterData);
      } else {
        setRolesList([]);
      }
    }
  }, [getRoleListSelector]);

  useEffect(() => {
    dispatch(getRoleList());
  }, []);
  useLayoutEffect(() => {
    if (!propertyFormSelector.update && propertyFormSelector?.response) {
      setFormState(propertyFormSelector?.response);
      setPropertyFields(
        propertyFormSelector?.response?.competitor_property || propertyFields
      );
      setPropertyAllocation(
        propertyFormSelector?.response?.property_allocation ||
        propertyAllocation
      );
      setInsetive(propertyFormSelector?.response?.insentive || insetiveState);
    }
  }, []);
  useEffect(() => {
    if (insentiveTypesSelector?.response) {
      const { response } = insentiveTypesSelector;
      if (response?.status === 200) {
        setInsentiveTypes(handleListResponse(response?.data));
      } else {
        setInsentiveTypes([]);
      }
    }
  }, [insentiveTypesSelector]);
  useEffect(() => {
    if (followUpSelector?.response) {
      const { response } = followUpSelector;
      if (response?.status === 200) {
        setLeadFollowUp(handleListResponse(response?.data));
      } else {
        setLeadFollowUp([]);
      }
    }
  }, [followUpSelector]);

  useEffect(() => {
    const { userData, parentUsers } = userListSelector;
    if (userData) {
      if (userData?.status === 200) {
        setUserList((prev) =>
          Array.from(
            [...prev, ...handleListResponse(userData?.data)]
              .reduce((m, o) => m.set(o._id, o), new Map())
              .values()
          )
        );
      } else {
        setUserList([]);
      }
    }
    if (parentUsers) {
      setParentUserList((prev) =>
        Array.from(
          [...prev, ...handleListResponse(parentUsers?.data)]
            .reduce((m, o) => m.set(o._id, o), new Map())
            .values()
        )
      );
    }
  }, [userListSelector]);

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    dispatch(getFollowupLead());
    dispatch(getInsentiveType());
    dispatch(getUserFilterDetail({ limit: 100, offset: 0 }));
  }, [dispatch]);

  const handleSelectMultiAllocation = (index, value) => {
    let data = [...propertyAllocation];
    data[index]["selectedUsers"] = value;
    data[index]["users"] = value.map((i) => i._id);
    setPropertyAllocation(data);
  };

  const handleManager = (result, value) => {
    let newSelectField = {
      role_id: value,
      users: [],
      selectedUsers: [],
    };

    setAllocationAddMore(true);
    return [...result, newSelectField];
  };

  const handleChangeAllocation = (index, event) => {
    let data = [...propertyAllocation];
    data[index][event.target.name] = event.target.value;
    data[index]["selectedUsers"] = [];
    data[index]["users"] = [];
    if (event.target.value !== strings.selectRole) {
      // if (event.target.value === SourcingTL) {
      //   data = handleManager(data, SourcingManager);
      // } else if (event.target.value === ClosingTL) {
      //   data = handleManager(data, ClosingManager);
      // }
      let obj = { [SourcingManager]: SourcingTL, [ClosingManager]: ClosingTL };
      if (obj[event.target.value]) {
        const managerData = data.filter(
          (so) => so.role_id === obj[event.target.value]
        );
        if (managerData.length > 0) {
          dispatch(
            parentUserList({
              role_id: managerData[0].role_id,
              user_id: managerData[0]["users"],
              isLoadMore: true,
            })
          );
        }
      } else {
        dispatch(
          getUserFilterDetail({ offset: 0, role_id: event.target.value })
        );
      }
    }
    setPropertyAllocation(data);
  };

  const handleInsetiveState = (index, event) => {
    let data = [...insetiveState];
    data[index][event.target.name] = event.target.value;
    setInsetive(data);
  };

  const addUploadFields = () => {
    let newUploadField = { file: "" };
    setUploadFields([...uploadFields, newUploadField]);
  };

  const removeFields = (index) => {
    let data = [...uploadFields];
    data.splice(index, 1);
    setUploadFields(data);
  };

  const removeField = (index) => {
    let data = [...propertyAllocation];
    data.splice(index, 1);
    setPropertyAllocation(data);
  };

  const removeInsentive = (index) => {
    let data = [...insetiveState];
    data.splice(index, 1);
    setInsetive(data);
  };

  const PropertyhandleChange = (index, event) => {
    let data = [...propertyFields];
    data[index][event.target.name] = event.target.value;
    setPropertyFields(data);
  };

  const addPropertyFields = () => {
    let newPropertyField = { property_name: "" };
    setPropertyFields([...propertyFields, newPropertyField]);
  };

  const removePropertyFields = (index) => {
    let data = [...propertyFields];
    data.splice(index, 1);
    setPropertyFields(data);
  };

  const addSelectFields = () => {
    let newSelectField = {
      role_id: "",
      users: [],
      selectedUsers: [],
    };
    setAllocationAddMore(true);
    setPropertyAllocation([...propertyAllocation, newSelectField]);
  };

  const addInsetiveState = () => {
    let newSelectField = { insentive_type_id: "", amount: "" };
    setInsetive([...insetiveState, newSelectField]);
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...formState,
      [e.target.name]: e.target.value,
    };
    setFormState(nextFormState);
  };
  const handleSubmit = () => {
    if (!handleValid()) {
      if (formState.amenity) {
        formState.amenity = formState?.amenity.map((i) => {
          i["amenity_id"] = i._id;
          return i;
        });
      }
      formState.property_image = uploadFields.map((i) => i.file);
      formState.competitor_property = propertyFields;

      formState.property_allocation = propertyAllocation;
      formState.insentive = insetiveState;
      dispatch(propertyForm(formState));
      navigatpage("/propertystepthird/");
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    // if (uploadFields.length === 1 && !uploadFields[0].file) {
    //   formError = true;
    //   err["property_image"] = strings.propertyImgErr;
    // }
    // if (!propertyFields[0].property_name) {
    //   formError = true;
    //   err["property_name"] = strings.propertynameErr;
    // }
    // if (!formState.lead_followup) {
    //   formError = true;
    //   err["lead_followup"] = strings.leadfollowupErr;
    // }
    // if (formState.lead_followup === strings.selectlead) {
    //   formError = true;
    //   err["lead_followup"] = strings.leadfollowupErr;
    // }
    if (!propertyAllocation[0].role_id) {
      formError = true;
      err["selectRole"] = strings.selectRoleErr;
    }
    if (propertyAllocation[0].selectedUsers.length === 0) {
      formError = true;
      err["selectUser"] = strings.selectUserErr;
    }
    if (propertyAllocation[0].selectedUsers.length === 0) {
      formError = true;
      err["selectManager"] = strings.selectManagerErr;
    }
    // if (!insetiveState[0].insentive_type_id) {
    //   formError = true;
    //   err["insentive_type_id"] = strings.insentiveErr;
    // }
    // if (!insetiveState[0].amount) {
    //   formError = true;
    //   err["amount"] = strings.amountErr;
    // } else if (isNaN(insetiveState[0].amount)) {
    //   formError = true;
    //   err["amount"] = strings.validAmount;
    // }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Add New Property",
      metaDescription: "Add property",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.addnewproperty}
        url={"/property"}
        parentListing={strings.propertyListing}
        titleactive={strings.addNewProperty}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.addnewproperty}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.Content}
                        {/* <span className="required-field"></span> */}
                      </label>
                      <div className="row mb-3">
                        {uploadFields &&
                          uploadFields.map((input, index) => {
                            return (
                              <div className="row col-md-11" key={index}>
                                <div className="col-md-9 mt-1">
                                  <input
                                    className="form-control"
                                    type="file"
                                    name="file"
                                    value={input.file.value}
                                    onChange={(event) => {
                                      const validFile =
                                        ValidateExtensionImgeVideo(
                                          event.target
                                        );
                                      let data = [...uploadFields];
                                      if (validFile === true) {
                                        data[index]["file"] =
                                          event.target.files;
                                        data[index]["validMedia"] = null;

                                        setUploadFields(data);
                                        setFormVaild({
                                          ...formVaild,
                                          property_image: null,
                                        });
                                      } else {
                                        data[index]["file"] = "";
                                        data[index]["validMedia"] = validFile;
                                        setUploadFields(data);
                                      }
                                    }}
                                  />
                                  {/* {formVaild.property_image && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.property_image}
                                    </span>
                                  )} */}
                                  {input.validMedia &&
                                    String(input.file) === "" && (
                                      <span style={{ color: "red" }}>
                                        {input.validMedia}
                                      </span>
                                    )}
                                </div>
                                {index != 0 && (
                                  <div className="col-md-1 mt-1">
                                    <Button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      onClick={() => removeFields(index)}
                                      label={"-"}
                                    ></Button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        <div className="col-md-1">
                          <Button
                            style={{ marginTop: "4px" }}
                            className="btn btn-success"
                            onClick={addUploadFields}
                            label={"+"}
                          ></Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*  */}
                  <div className="row align-items-center">
                    <div className="col">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.addCompetitorProperty}
                        {/* <span className="required-field"></span> */}
                      </label>

                      <div className="row mb-3">
                        {propertyFields &&
                          propertyFields.map((property, index) => {
                            return (
                              <div className="col-md-11 row" key={index}>
                                <div className="col-md-9 mt-1">
                                  <input
                                    className="form-control"
                                    autoComplete="off"
                                    id="exampleFormControlFirstName"
                                    type="text"
                                    placeholder={strings.propertyName}
                                    name="property_name"
                                    value={property.property_name}
                                    onChange={(event) =>
                                      PropertyhandleChange(index, event)
                                    }
                                  />
                                  {/* {formVaild.property_name && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.property_name}
                                    </span>
                                  )} */}
                                </div>
                                {index != 0 && (
                                  <div className="col-md-1 mt-1">
                                    <Button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      onClick={() =>
                                        removePropertyFields(index)
                                      }
                                      label={"-"}
                                    ></Button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        <div className="col-md-1">
                          <Button
                            style={{ marginTop: "5px" }}
                            className="btn btn-success"
                            onClick={addPropertyFields}
                            label={"+"}
                          ></Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.leadFollowup}
                          {/* <span className="required-field"></span> */}
                        </label>

                        <select
                          className="form-control digits"
                          id="exampleFormControlSelect9"
                          name="lead_followup"
                          value={formState.lead_followup}
                          onChange={handleInputField}
                        >
                          <option value="">
                            {strings.selectlead}
                          </option>
                          {leadFollowUp.length > 0 ? (
                            leadFollowUp.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                        {/* {formVaild.lead_followup && (
                          <span style={{ color: "red" }}>
                            {formVaild.lead_followup}
                          </span>
                        )} */}
                      </div>
                    </div>
                  </div>
                  <div className="row row-margin">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.propertyAllocation}
                          {" (One required)"}
                          <span className="required-field"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {propertyAllocation &&
                      propertyAllocation.map((select, index) => {
                        return (
                          (rolesList.some((i) => i._id === select.role_id) ||
                            select.role_id === "" ||
                            select.selectedUsers.length === 0) && (
                            <div className="col-md-11 row" key={index}>
                              <div className="col-md-5">
                                <div className="mb-3">
                                  <select
                                    className="form-control digits"
                                    id="exampleFormControlSelect9"
                                    value={select.role_id}
                                    name="role_id"
                                    onChange={(event) =>
                                      handleChangeAllocation(index, event)
                                    }
                                  >
                                    <option value="">
                                      {strings.selectRole}
                                    </option>
                                    {rolesList &&
                                      rolesList.map((item, i) => {
                                        let isSourcingTL =
                                          propertyAllocation.some(
                                            ({ role_id }) =>
                                              role_id === SourcingTL
                                          )
                                            ? true
                                            : item._id !== SourcingManager;
                                        let isClosingTL =
                                          propertyAllocation.some(
                                            ({ role_id }) =>
                                              role_id === ClosingTL
                                          )
                                            ? true
                                            : item._id !== ClosingManager;
                                        return (
                                          isSourcingTL &&
                                          isClosingTL && (
                                            <option
                                              key={i}
                                              value={item._id}
                                              disabled={propertyAllocation.some(
                                                ({ role_id }) =>
                                                  role_id === item._id
                                              )}
                                            >
                                              {item.role_title}
                                            </option>
                                          )
                                        );
                                      })}
                                  </select>
                                  {/* )} */}
                                  {formVaild.selectRole && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.selectRole}
                                    </span>
                                  )}
                                  {/* {!select.role_id && (
                                  <span style={{ color: "red" }}>
                                    {formVaild.selectRole}
                                  </span>
                                )} */}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Select
                                    isSearchable
                                    isMulti
                                    placeholder={strings.selectUser}
                                    options={
                                      select.role_id === SourcingManager ||
                                        select.role_id === ClosingManager
                                        ? ParentUserList.filter(
                                          (i) => i.role_id === select.role_id
                                        )
                                        : userList.filter(
                                          (i) => i.role_id === select.role_id
                                        )
                                    }
                                    getOptionLabel={(option) =>
                                      `${option.user_name}`
                                    }
                                    getOptionValue={(option) => option._id}
                                    name="selectedUsers"
                                    value={select.selectedUsers}
                                    onChange={(val) => {
                                      handleSelectMultiAllocation(index, val);
                                    }}
                                  />
                                  {formVaild.selectUser && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.selectUser}
                                    </span>
                                  )}
                                </div>
                              </div>

                              {index != 0 && (
                                <div className="col-md-1">
                                  <Button
                                    className="btn btn-danger"
                                    onClick={() => removeField(index)}
                                    label={"-"}
                                  ></Button>
                                </div>
                              )}
                            </div>
                          )
                        );
                      })}
                    <div className="col-md-1">
                      <Button
                        className="btn btn-success"
                        onClick={addSelectFields}
                        disabled={allocationAddMore}
                        label={"+"}
                      ></Button>
                    </div>
                  </div>

                  <div className="row row-margin">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.insentive}
                          {" (One required)"}
                          {/* <span className="required-field"></span> */}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {insetiveState &&
                      insetiveState.map((select, index) => {
                        return (
                          <div className="col-md-11 row" key={index}>
                            <div className="col-md-5">
                              <div className="mb-3">
                                <select
                                  className="form-control digits"
                                  id="exampleFormControlSelect9"
                                  value={select.insentive_type_id}
                                  name="insentive_type_id"
                                  onChange={(event) =>
                                    handleInsetiveState(index, event)
                                  }
                                >
                                  <option value="">
                                    {strings.selectType}
                                  </option>
                                  {insentiveTypes.length > 0 ? (
                                    insentiveTypes.map((item, i) => (
                                      <option
                                        key={i}
                                        value={item._id}
                                        disabled={insetiveState.some(
                                          ({ insentive_type_id }) =>
                                            insentive_type_id === item._id
                                        )}
                                      >
                                        {item.title}
                                      </option>
                                    ))
                                  ) : (
                                    <option>{strings.Loading}</option>
                                  )}
                                </select>
                                {/* {formVaild.insentive_type_id && index === 0 && (
                                  <span style={{ color: "red" }}>
                                    {formVaild.insentive_type_id}
                                  </span>
                                )} */}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <input
                                  className="form-control"
                                  autoComplete="off"
                                  id="exampleFormControlFirstName"
                                  type="number"
                                  name="amount"
                                  value={select.amount}
                                  placeholder={strings.amount}
                                  onChange={(event) =>
                                    handleInsetiveState(index, event)
                                  }
                                  onKeyPress={(e) => {
                                    if (e.target.value.length >= 10) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {/* {formVaild.amount && index === 0 && (
                                  <span style={{ color: "red" }}>
                                    {formVaild.amount}
                                  </span>
                                )} */}
                              </div>
                            </div>

                            {index != 0 && (
                              <div className="col-md-1">
                                <Button
                                  className="btn btn-danger"
                                  onClick={() => removeInsentive(index)}
                                  label={"-"}
                                ></Button>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    <div className="col-md-1">
                      <Button
                        className="btn btn-success"
                        onClick={addInsetiveState}
                        label={"+"}
                      ></Button>
                    </div>
                  </div>

                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div>
                        <label htmlFor="exampleFormControlLastName">
                          {strings.pickupAllowed} (Optional)
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary ">
                              <input
                                id="radioinline4"
                                type="radio"
                                name="pickup"
                                value={"Yes"}
                                checked={
                                  formState.pickup === "Yes" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline4">
                                {strings.yes}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-4">
                              <input
                                id="radioinline5"
                                type="radio"
                                name="pickup"
                                value={"No"}
                                checked={
                                  formState.pickup === "No" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" htmlFor="radioinline5">
                                {strings.no}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <Button
                        className="btn btn-color"
                        onClick={() => handleSubmit()}
                        label={strings.next}
                      ></Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddNewPropNext;
